import { render, staticRenderFns } from "./KomoditiView.vue?vue&type=template&id=abd424a0&scoped=true"
import script from "./KomoditiView.vue?vue&type=script&lang=js"
export * from "./KomoditiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd424a0",
  null
  
)

export default component.exports